<template>
    <div>
        <HeaderReceipt header="สินค้ารอย้ายเข้าคลังใกล้หมดอายุ" :img_header="header_image" link_back="stock/storage/mainstorage"/>
        <Storage_exp/>
    </div>
</template>

<script>
    import HeaderImage from '@/assets/shelf-life.png'
    import HeaderReceipt from "@/components/admin/stock/menustorage/HeaderReceipt.vue";
    import Storage_exp from "@/components/admin/stock/storage_expire/Storage_exp.vue";

    export default {
        name: "ExpStorage",
        components: {
            Storage_exp,
            HeaderReceipt
        },
        data() {
            return {
                header_image: HeaderImage
            }
        }
    }
</script>

<style scoped>

</style>
